import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { store } from './store';
import { sessionExpired } from './store/authSlice';
import { registerSessionExpiredHandler } from './services/authSession';
import './styles/index.css';
import './styles/hdp.css';

registerSessionExpiredHandler(() => {
  store.dispatch(sessionExpired());
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
